import { Navigate } from "react-router-dom"

export default function ProtectedRoute({ children }) {
    const authToken = localStorage.getItem("chaperon_auth_token")

    if (!authToken) {
        // Redirect to login page if not authenticated
        return <Navigate to="/user/login" replace />
    }

    return children
}
